export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14200.6ae145f9.jpg";